import React from 'react'

const Ellipse = ({ stroke = '#FFD29D' }) => (
  <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='28' cy='28' r='25' stroke={stroke} strokeWidth='6' />
  </svg>
)

export default Ellipse
